import { Component, OnInit } from "@angular/core";
import { ICompany } from "src/app/interfaces/company";
import { TranslateService } from "@ngstack/translate";
import { MatDialog, MatSelectChange } from "@angular/material";

import { IConfirm } from "src/app/interfaces/confirm";
import { CIDService } from "src/app/services/common/cid.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IEducationPackage } from "src/app/interfaces/educationPackage";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { AddPackageEntryComponent } from "../add-package-entry/add-package-entry.component";
import { PlacementTypeEntryComponent } from "../placement-type-entry/placement-type-entry.component";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { environment } from "src/environments/environment.prod";
import { AddLevelToPackageComponent } from "../add-level-to-package/add-level-to-package.component";

@Component({
  selector: "app-package-list",
  templateUrl: "./package-list.component.html",
  styleUrls: ["./package-list.component.css"]
})
export class PackageListComponent implements OnInit {
  url = environment.BaaseUrl;
  isOwner: boolean;
  companyCode: string;
  companyList: ICompany;
  companySelected: string;
  regularDistribution = 100 / 3;
  eduPackageList: IEducationPackage;
  dataSource: any = [];
  displayedColumns: string[] = [
    "picture",
    this.translate.get("label.title"),
    this.translate.get("label.ageGroup"),
    // this.translate.get("label.publicPackage"),
    "function"
  ];

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private eduPackageService: EducationPackageService
  ) {}

  ngOnInit() {
    this.checkOwner();
    this.getEduPackageList();
    this.companySelected = this.cidService.getCID();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      if (res.IsOwner) {
        this.getCompanyList();
      }
      this.isOwner = res.IsOwner;
    });
  }

  getEduPackageList() {
    this.eduPackageService.getList(0, 0).subscribe(res => {
      this.dataSource = res.DataList;
      this.companySelected = this.cidService.getCID();
    });
  }

  add() {
    this.dialog
      .open(AddPackageEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.getEduPackageList();
      });
  }

  edit(data: IEducationPackage) {
    this.dialog
      .open(AddPackageEntryComponent, {
        data: data
      })
      .afterClosed()
      .subscribe(() => {
        this.getEduPackageList();
      });
  }

  delete(data: IEducationPackage) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: data.PackageName
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.eduPackageService.delete(data).subscribe(() => {
              this.getEduPackageList();
            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }

  placementEntry(data: IEducationPackage) {
    this.dialog.open(PlacementTypeEntryComponent, {
      data: data,
     // minWidth: "600px",
      width: "850px",
      disableClose: true

     // maxHeight: "600px"
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(
      res => {
        this.companyList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPackageList(e: MatSelectChange) {
    this.companyCode = e.value;
    this.cidService.setCID(e.value);
    this.getEduPackageList();
  }

  assignLevelToBranches(e) {
    this.dialog.open(AddLevelToPackageComponent, {
      data: e
    });
  }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
